import React from "react";

const Footer = () => {
  return (
    <div className=" flex flex-col md:flex-row justify-between mx-auto w-[80%] items-center py-4 box-border">
      <p className=" text-neutral-400 text-sm">
        ©This Website belongs to Om Gate
      </p>
      <ul className=" mt-4 flex items-center justify-center gap-8">
        <li>
          <a
            href="https://github.com/omgate23"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-github text-lg text-white"></i>
          </a>
        </li>
        <li>
          <a
            href="https://linkedin.com/in/omgate"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-linkedin text-lg text-white"></i>
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/om_gate"
            target="_blank"
            rel="noreferrer"
          >
            <i class="fa-brands fa-twitter text-lg text-white"></i>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Footer;
